/* ControlAdapterRegistry.js */

"use strict";

var CONTROL_TYPE = require("../typedefinitions/formcontrol/FormControlType.enum");
var UNDERLING_TYPE = require("../typedefinitions/formcontrol/UnderlingType.enum");
var VALUE_SCOPE_TYPE = require("../typedefinitions/formcontrol/ValueScope.type");
var _ = require("lodash");
var $ = require("jquery");
var underscoreString = require("underscore.string");
_.mixin(underscoreString.exports());

/**
 * Create or retreive the containing element for the given form control definition.
 * @param parentElem {DomElement} The Parent element that fcd is contained within
 * @param fcd {FormControlDefinition} The form control definition that will be contained.
 * @param classes {Array.<String>} Classes to add to the container element
 * @returns {DomElement} The dom element passed to the form control's adapter class
 */
function createSimpleContainer(parentElem, fcd, classes) {
    var classStr = "rendered_control";
    if (classes && _.isArray(classes)) {
        classes.forEach(function (clss) {
            classStr += " " + clss;
        });
    }
    //add required class
    if (fcd.validationInfo && fcd.validationInfo.required) {
        classStr += " required";
    }

    //If the fcd is hidden
    if (fcd.configSettings.Display && fcd.configSettings.Display.hidden) {
        classStr += " hidden";
    }

    var typeAsClassName = _.underscored(fcd.type);
    classStr += " " + typeAsClassName;
    var nameAsClassName = _.underscored(fcd.name);
    classStr += " " + nameAsClassName;

    var ctrlElem = $('<div class="' + classStr + '"></div>');
    parentElem.append(ctrlElem);
    return ctrlElem;
}

function createLabelContainer(parentElem, fcd, classes = [], labelClasses = []) {
    var classStr = "rendered_control";
    var typeAsClassName = _.underscored(fcd.type);
    classStr += " " + typeAsClassName;
    var nameAsClassName = _.underscored(fcd.name);
    classStr += " " + nameAsClassName;

    if (classes && _.isArray(classes)) {
        classes.forEach(function (clss) {
            classStr += " " + clss;
        });
    }
    //add required class
    if (fcd.validationInfo && fcd.validationInfo.required) {
        classStr += " required";
    }

    //If the fcd is hidden
    if (fcd.configSettings.Display && fcd.configSettings.Display.hidden) {
        classStr += " hidden";
    }

    var indent = "";
    var startTextTag = "<label";
    var endTextTag = "</label>";
    let labelClassStr = _.join(labelClasses, " ");
    //If the fcd display indent
    if (fcd.configSettings.Display && fcd.configSettings.Display.formatLabel) {
        startTextTag = "<pre";
        endTextTag = "</pre>";
    }

    var ctrlElem = $(
        '<div class="' +
            classStr +
            '">' +
            startTextTag +
            ' title="' +
            fcd.displayInfo.tooltip +
            '" class="' +
            labelClassStr +
            '">' +
            indent +
            fcd.displayInfo.label +
            endTextTag +
            "</div>"
    );
    parentElem.append(ctrlElem);
    return ctrlElem;
}

function createTabContainer(parentElem, fcd, classes) {
    var classStr = "rendered_control";
    if (classes && _.isArray(classes)) {
        classes.forEach(function (clss) {
            classStr += " " + clss;
        });
    }
    //add required class
    if (fcd.validationInfo && fcd.validationInfo.required) {
        classStr += " required";
    }

    //If the fcd is hidden
    if (fcd.configSettings.Display && fcd.configSettings.Display.hidden) {
        classStr += " hidden";
    }

    classStr += " tab_box";

    var typeAsClassName = _.underscored(fcd.type);
    classStr += " " + typeAsClassName;
    var nameAsClassName = _.underscored(fcd.name);
    classStr += " " + nameAsClassName;
    var ctrlElem = $('<div class="' + classStr + '"></div>');
    var tabContainer = $(
        '<div class="rendered_control tab_container" ng-show="tabInfo[tabName].currentTabNum === containerTabNum"></div>'
    );
    ctrlElem.append(tabContainer);
    parentElem.append(ctrlElem);
    return ctrlElem;
}

//TEXT
module.exports[CONTROL_TYPE.TEXT] = {
    type: UNDERLING_TYPE.CONTROL_ADAPTER,
    adapterClass: require("./controladapters/text.control_adapter"),
    valueScope: VALUE_SCOPE_TYPE.ISOLATED,
    adapterClassFactory: function (fcd) {
        let refAdapter = require("./controladapters/text.control_adapter");
        if (_.has(fcd, "configSettings.Display.editor")) {
            refAdapter = require("./controladapters/text_editor.control_adapter");
        }
        return refAdapter;
    },
    createAdapterContainingElement: function (parentElem, fcd) {
        if (_.has(fcd, "configSettings.Display.editor")) {
            return createLabelContainer(parentElem, fcd, ["editor_control"]);
        } else {
            return createLabelContainer(parentElem, fcd);
        }
    },
};
//NUMBER
module.exports[CONTROL_TYPE.NUMBER] = {
    type: UNDERLING_TYPE.CONTROL_ADAPTER,
    adapterClass: require("./controladapters/number.control_adapter"),
    valueScope: VALUE_SCOPE_TYPE.ISOLATED,
};
//BOOLEAN
module.exports[CONTROL_TYPE.BOOLEAN] = {
    type: UNDERLING_TYPE.CONTROL_ADAPTER,
    adapterClass: require("./controladapters/boolean.control_adapter"),
    valueScope: VALUE_SCOPE_TYPE.ISOLATED,
    createAdapterContainingElement: createSimpleContainer,
};
//OBJECT
module.exports[CONTROL_TYPE.OBJECT] = {
    type: UNDERLING_TYPE.CONTROL_ADAPTER,
    adapterClass: require("./controladapters/object.control_adapter"),
    valueScope: VALUE_SCOPE_TYPE.ISOLATED,
    createAdapterContainingElement: function (parentElem, fcd) {
        return createLabelContainer(parentElem, fcd, ["nested"], ["legend"]);
    },
};
//TAB_OBJECT
module.exports[CONTROL_TYPE.TAB_OBJECT] = {
    type: UNDERLING_TYPE.CONTROL_ADAPTER,
    adapterClass: require("./controladapters/tabObject.control_adapter.js"),
    valueScope: VALUE_SCOPE_TYPE.ISOLATED,
    createAdapterContainingElement: function (parentElem, fcd) {
        return createTabContainer(parentElem, fcd, ["nested"]);
    },
};
//TAB_ARRAY
module.exports[CONTROL_TYPE.TAB_ARRAY] = {
    type: UNDERLING_TYPE.CONTROL_ADAPTER,
    adapterClass: require("./controladapters/tabArray.control_adapter"),
    valueScope: VALUE_SCOPE_TYPE.ISOLATED,
    createAdapterContainingElement: function (parentElem, fcd) {
        return createTabContainer(parentElem, fcd, ["nested"]);
    },
};
//TABGROUP
module.exports[CONTROL_TYPE.TAB_GROUP] = {
    type: UNDERLING_TYPE.CONTROL_ADAPTER,
    adapterClass: require("./controladapters/tabgroup.control_adapter"),
    valueScope: VALUE_SCOPE_TYPE.PARENT,
    createAdapterContainingElement: function (parentElem, fcd) {
        return createSimpleContainer(parentElem, fcd, ["nested"]);
    },
};
//ARRAY
module.exports[CONTROL_TYPE.ARRAY] = {
    type: UNDERLING_TYPE.CONTROL_ADAPTER,
    adapterClass: require("./controladapters/array.control_adapter"),
    adapterClassFactory: function (fcd) {
        let refAdapter = require("./controladapters/array.control_adapter");
        if (
            _.has(fcd, "configSettings.Display.tagList") ||
            _.has(fcd, "configSettings.Display.pickList")
        ) {
            if (
                _.has(fcd, "configSettings.value[0].value") &&
                _.isObject(fcd.configSettings.value[0].value)
            ) {
                console.warn("Complex object array cannot be a tagList");
                refAdapter = require("./controladapters/unknown.control_adapter");
            } else {
                refAdapter = require("./controladapters/array_component.control_adapter");
            }
        } else if (
            _.has(fcd, "configSettings.Display.table") &&
            _.isObject(fcd.configSettings.value[0].value)
        ) {
            refAdapter = require("./controladapters/array_grid.control_adapter");
        }
        return refAdapter;
    },
    valueScope: VALUE_SCOPE_TYPE.ISOLATED,
    // createAdapterContainingElement: function (parentElem, fcd) {
    //     return createSimpleContainer(parentElem, fcd, ["nested"]);
    // },
    createAdapterContainingElement: function (parentElem, fcd) {
        if (_.has(fcd, "configSettings.Display.tagList")) {
            return createLabelContainer(parentElem, fcd, ["tags"]);
        } else if (fcd.name === "@Complete") {
            return createSimpleContainer(parentElem, fcd, ["nested"]);
        } else {
            return createLabelContainer(parentElem, fcd, ["nested"], ["legend"]);
        }
    },
};
//ENUM
module.exports[CONTROL_TYPE.ENUM] = {
    type: UNDERLING_TYPE.CONTROL_ADAPTER,
    adapterClass: require("./controladapters/enum.control_adapter"),
    valueScope: VALUE_SCOPE_TYPE.ISOLATED,
    adapterClassFactory: function (fcd) {
        let adapter = require("./controladapters/enum.control_adapter");
        if (_.has(fcd, "configSettings.Display.radioButton")) {
            adapter = require("./controladapters/enum_radio.control_adapter");
        }
        return adapter;
    },
};
//@Select.options
module.exports[CONTROL_TYPE.SELECT_OPTIONS] = {
    type: UNDERLING_TYPE.CONTROL_ADAPTER,
    adapterClass: require("./controladapters/select_options.control_adapter"),
    valueScope: VALUE_SCOPE_TYPE.PARENT,
    createAdapterContainingElement: function (parentElem, fcd) {
        return createSimpleContainer(parentElem, fcd, ["nested"]);
    },
};
//@Choice.options
module.exports[CONTROL_TYPE.CHOICE_OPTIONS] = {
    type: UNDERLING_TYPE.CONTROL_ADAPTER,
    adapterClass: require("./controladapters/choice_options.control_adapter"),
    valueScope: VALUE_SCOPE_TYPE.REPLACE,
};
//@Complete.options
module.exports[CONTROL_TYPE.COMPLETE_OPTIONS] = {
    type: UNDERLING_TYPE.CONTROL_ADAPTER,
    adapterClass: require("./controladapters/complete_options.control_adapter"),
    valueScope: VALUE_SCOPE_TYPE.OBJECT,
    createAdapterContainingElement: createSimpleContainer,
};
//@Complete.allType
module.exports[CONTROL_TYPE.COMPLETE_ALL_TYPE] = {
    type: UNDERLING_TYPE.CONTROL_ADAPTER,
    adapterClass: require("./controladapters/complete_all_type.control_adapter"),
    valueScope: VALUE_SCOPE_TYPE.OBJECT,
    createAdapterContainingElement: createSimpleContainer,
};
//@Ref
module.exports[CONTROL_TYPE.REF] = {
    type: UNDERLING_TYPE.CONTROL_ADAPTER,
    adapterClass: require("./controladapters/ref.control_adapter"),
    adapterClassFactory: function (fcd) {
        let refAdapter = require("./controladapters/ref.control_adapter");
        if (
            fcd.configSettings.Ref.many &&
            (_.get(fcd, "configSettings.Display.ref.showReOrder") ||
                _.get(fcd, "configSettings.Display.ref.showReorder"))
        ) {
            // Picklist takes precedence on display.
            if (_.has(fcd, "configSettings.Display.pickList")) {
                refAdapter = require("./controladapters/ref.control_adapter");
            } else {
                refAdapter = require("./controladapters/ref_list.control_adapter");
            }
        }
        return refAdapter;
    },
    valueScope: VALUE_SCOPE_TYPE.ISOLATED,
    createAdapterContainingElement: function (parentElem, fcd) {
        let pickList = _.get(fcd, "configSettings.Display.pickList");
        if (fcd.configSettings.Ref.many && _.get(fcd, "configSettings.Display.ref") && !pickList) {
            return createSimpleContainer(parentElem, fcd, ["nested"]);
        } else {
            let classes = [],
                labelClasses = [];
            if (pickList) {
                classes = ["nested"];
                labelClasses = ["legend"];
            }
            return createLabelContainer(parentElem, fcd, classes, labelClasses);
        }
    },
};
module.exports[CONTROL_TYPE.NULL] = {
    type: UNDERLING_TYPE.CONTROL_ADAPTER,
    adapterClass: require("./controladapters/null.control_adapter"),
    valueScope: VALUE_SCOPE_TYPE.ISOLATED,
};
module.exports[CONTROL_TYPE.REGEX] = {
    type: UNDERLING_TYPE.CONTROL_ADAPTER,
    adapterClass: require("./controladapters/regex_editor.control_adapter"),
    valueScope: VALUE_SCOPE_TYPE.ISOLATED,
};
//Unknown
module.exports[CONTROL_TYPE.UNKNOWN] = {
    type: UNDERLING_TYPE.CONTROL_ADAPTER,
    adapterClass: require("./controladapters/unknown.control_adapter"),
    valueScope: VALUE_SCOPE_TYPE.ISOLATED,
};
